const status: { available: string; chat: string; dnd: string; away: string } = Object.freeze({
  available: 'available',
  chat: 'chat',
  dnd: 'dnd',
  away: 'away'
});

export default status;
